import EventObject from "../../../modules/tracking/EventObject";

export default function(onclick) {
    const container = document.createElement('div');
    container.classList.add('live-chat-card__btn-container');

    // const whatsAppLink = document.createElement('a');
    // whatsAppLink.classList.add('live-chat-card__whatsapp');
    // whatsAppLink.setAttribute('target', '_blank');
    // whatsAppLink.setAttribute('href', 'https://wa.me/442476851458');

    // const whatsAppImage = document.createElement('img');
    // whatsAppImage.classList.add('live-chat-card__whatsapp-img');
    // whatsAppImage.src = '/images/live-chat/whatsapp.svg';
    // whatsAppImage.addEventListener('click', function() {
    //     new EventObject('Live Chat', 'WhatsApp', 'Opened').dispatch();
    // })
    // whatsAppLink.append(whatsAppImage);

    // container.appendChild(whatsAppLink);

    const chatButton = document.createElement('button');
    chatButton.classList.add('btn--chat');
    chatButton.style.cursor = 'pointer';

    chatButton.innerHTML = `
    <img src="/images/redesign/live-chat/live-chat.svg" 
        alt="Start Chat" 
        width="34" 
        height="34"
        style="display:block;" />
    `;

    chatButton.addEventListener('click', onclick);

    container.appendChild(chatButton);

    return container;
}